import axios from 'axios';
import store from '../store/store';
import * as toastr from 'toastr';
import './/../../node_modules/toastr/build/toastr.css'; //You need style and css loader installed and set

class axiosService {
    static get api() {
        let env = process.env.NODE_ENV || 'development';
        let config = require('../../config')[env];
        const instance = axios.create({
            baseURL: config.api,
            timeout: 30000,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': localStorage.getItem('token')
            }
        })

        instance.interceptors.response.use(function (response) {
            store.commit('set_http_error', null);
            return response;
        }, function (error) {
            //toastr.optons.timeOut = 10;
            toastr.options = {
                positionClass:
                 "toast-bottom-center",
                 //"toast-bottom-full-width",
                timeOut: "8000",
                toastClass: 'error',
                showMethod: "fadeIn",
                hideMethod: "fadeOut"
            }

            //toastr.options.positionClass = "toast-bottom-full-width";
            toastr.error(error.response.data.message)
            // Do something with request error
            store.commit('set_http_error', error)
            return Promise.reject(error)
        })
        return instance;
    }
}


export default axiosService;